import React, { useEffect, useState } from "react";
import { FormLocationSelector } from "components/form-fields";
import { Intent } from "@blueprintjs/core";
import { useDispatch, useSelector } from "react-redux";
import { HubTile } from "components/hubs/hub-tile";
import { LicenceCheckingService } from "services";
import { NotificationToaster } from "components/notifications";
import axios from "axios";
import "./GreyFleetOverview.css";

export function GreyFleetOverview() {
    //General
    const [isLoading, setIsLoading] = useState(true);
    // Location selector
    const dispatch = useDispatch();
    const reduxLocations = useSelector(
        (state) => state.licenceChecking.locations
    );
    const [useHierarchy, setUseHierarchy] = useState(true);
    const [useLocationDefaults, setUseLocationDefaults] = useState(null);
    //Data
    const [licenceCheckingOptions, setLicenceCheckingOptions] = useState([]);
    const [onboardingGreyFleet, setOnboardingGreyFleet] = useState([]);
    const [enrolledGreyFleet, setEnrolledGreyFleet] = useState([]);
    //UI
    const [onboardingTiles, setOnboardingTiles] = useState([
        <HubTile key={1} isLoading />,
        <HubTile key={2} isLoading />,
        <HubTile key={3} isLoading />,
        <HubTile key={4} isLoading />,
        <HubTile key={5} isLoading />,
        <HubTile key={6} isLoading />,
        <HubTile key={7} isLoading />,
    ]);
    const [enrolledTiles, setEnrolledTiles] = useState([
        <HubTile key={1} isLoading />,
        <HubTile key={2} isLoading />,
        <HubTile key={3} isLoading />,
        <HubTile key={4} isLoading />,
        <HubTile key={5} isLoading />,
        <HubTile key={6} isLoading />,
        <HubTile key={7} isLoading />,
        <HubTile key={8} isLoading />,
        <HubTile key={9} isLoading />,
        <HubTile key={10} isLoading />,
        <HubTile key={11} isLoading />,
    ]);

    useEffect(() => {
        if (reduxLocations && reduxLocations.length > 0) {
            setUseLocationDefaults(false);
        } else {
            setUseLocationDefaults(true);
        }

        getGreyFleetStats();
    }, [reduxLocations]);

    useEffect(() => {
        if (
            !licenceCheckingOptions ||
            onboardingGreyFleet.length === 0 ||
            enrolledGreyFleet.length === 0
        ) {
            return;
        }

        setOnboardingTiles(
            onboardingGreyFleet.map((item) => {
                let option = getOptionById(item.id);
                return (
                    <HubTile
                        key={item.id}
                        title={option.name}
                        count={item.count}
                        colour={option.displayColour}
                        link={`/licence-checking/grey-fleet/checks?filter=${option.key}`}
                    />
                );
            })
        );

        setEnrolledTiles(
            enrolledGreyFleet.map((item) => {
                let option = getOptionById(item.id);
                return (
                    <HubTile
                        key={item.id}
                        title={option.name}
                        count={item.count}
                        colour={option.displayColour}
                        link={`/licence-checking/grey-fleet/checks?filter=${option.key}`}
                    />
                );
            })
        );
    }, [licenceCheckingOptions, onboardingGreyFleet, enrolledGreyFleet]);

    function getOptionById(id) {
        return licenceCheckingOptions.find((x) => x.id === id);
    }

    function onSelectedLocationsChange(locations) {
        dispatch({
            type: "SET_LICENCE_CHECKING_LOCATIONS",
            payload: locations,
        });
    }

    function getGreyFleetStats() {
        setIsLoading(true);

        axios
            .all([
                LicenceCheckingService.getLicenceCheckingOptions(),
                LicenceCheckingService.getGreyFleetStats(reduxLocations),
            ])
            .then(
                axios.spread(function (options, greyFleetStats) {
                    let checkFilters = options.greyFleetCheckFilters;
                    setLicenceCheckingOptions(checkFilters);

                    // Filtering logic
                    const onboardingGreyFleetFiltered = [];
                    const enrolledGreyFleetFiltered = [];

                    // Ensure greyFleetStats is an array
                    const statsArray = Array.isArray(greyFleetStats)
                        ? greyFleetStats
                        : [];

                    checkFilters.forEach((filter) => {
                        const stat = statsArray.find((s) => s.id === filter.id);
                        if (stat) {
                            if (filter.sectionKey === "ONBOARDING") {
                                onboardingGreyFleetFiltered.push(stat);
                            } else if (filter.sectionKey === "ENROLLED") {
                                enrolledGreyFleetFiltered.push(stat);
                            }
                        }
                    });

                    setOnboardingGreyFleet(onboardingGreyFleetFiltered);
                    setEnrolledGreyFleet(enrolledGreyFleetFiltered);
                }),
                () => {
                    NotificationToaster.show(
                        Intent.DANGER,
                        "Unable to load data. Please refresh the page."
                    );
                }
            )
            .catch(() => {
                NotificationToaster.show(
                    Intent.DANGER,
                    "Unable to load data. Please refresh the page."
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            <div className="inline-items spacer-bottom">
                <FormLocationSelector
                    businessArea={"Tacho"}
                    loading={false}
                    selectedLocations={reduxLocations}
                    setSelectedLocations={onSelectedLocationsChange}
                    useLocationDefaults={useLocationDefaults}
                    useHierarchy={useHierarchy}
                    setUseHierarchy={setUseHierarchy}
                    locationDefaultsToTrue={isLoading ? null : true}
                />
            </div>

            <h2>Onboarding Grey Fleet</h2>
            <div className="grey-fleet-tile-row spacer-bottom">
                {onboardingTiles}
            </div>

            <h2>Enrolled Grey Fleet</h2>
            <div className="grey-fleet-tile-row spacer-bottom">
                {enrolledTiles}
            </div>
        </>
    );
}
